import styled from 'styled-components';
import { fonts, colors } from 'stylesheets';

export const Content = styled.div`
  ${({ isLoading }) => isLoading && 'height: 400px'}
  max-height: 400px !important;
  text-align: center;
`;

export const ContentText = styled.p`
  font-family: ${fonts.primary};
  margin-top: ${({ marginTop }) => marginTop || 0}px;
  text-align: ${({ textAlign }) => textAlign || 'center'};
  margin-left: ${({ marginLeft }) => marginLeft || 0}px;
`;

export const SelectButtons = styled.div`
  display: flex;
  justify-content: center;
`;

export const Button = styled.a`
  cursor: pointer;
  font-size: 15px;
  font-family: Montserrat;
  border-radius: 8px;
  padding: 12px;
  margin: 10px;
  color: #565656;
  border: 1px solid #cbcbcb;
  &.active {
    border-color: ${colors.primary};
    color: ${colors.primary} !important;
  }
`;

export const BoxLoader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const PaymentInfo = styled.div`
  margin: 10px 10%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  & div {
    max-width: 100% !important;
  }
`;

export const TextAreaStyled = styled.textarea`
  width: 90%;
  height: 100px;
  resize: none;
  padding: 10px;
  border: 1px solid #A1A1A1;
  border-radius: 4px;
  background: #FFFFFF;

  ::placeholder {
    color: #DDDDDD;
    font-family: 'Roboto', sans-serif;
    font-style: italic;
    font-weight: normal;
    font-size: 14px;
    line-height: 24px;
  }
`;
